import React from 'react'
import { makeStyles } from '@material-ui/core'
import TextField from '@material-ui/core/TextField'
import Geosuggest from 'react-geosuggest'
import { red } from '@material-ui/core/colors'
import Decades from './Decades'
import { validateMonth, validateYear } from './inputValidator'

const useStyles = makeStyles((theme) => {
  return {
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      marginTop: 16,
      minWidth: 200,
    },
    storyTextField: {
      width: 300,
    },
    question: {
      fontFamily: 'Montserrat',
      color: '#818284',
      letterSpacing: -0.4,
      marginBottom: 16,
    },
  }
})

export default function MoreInfo(props) {
  const { change, decade, decades, moreInfo, error, changeDecade } = props

  const classes = useStyles()

  const handleChange = (id, e) => {
    const copy = { ...moreInfo }
    const value = e.target.value

    switch (id) {
    case 'year':
      copy.year = value
      if (validateYear(copy.year).isValid) copy.month = ''
      break
    case 'month':
      copy.month = value
      if (validateMonth(copy.month).isValid) copy.day = ''
      break
    case 'day':
      copy.day = value
      break
    case 'caption':
      copy.caption = value
      break
    case 'desc':
      copy.desc = value
      break
    default:
      console.error('should not be here')
    }

    change(copy)
  }

  const onSuggestSelect = (suggest) => {
    if (!suggest) return
    const copy = { ...moreInfo }
    copy.location = {
      label: suggest.label,
      coords: suggest.location,
    }
    change(copy)
  }

  return (
    <div>
      <Decades decade={decade} decades={decades} change={changeDecade} />
      <div className={classes.question} style={{ marginTop: 16 }}>
        If you know the exact date, fill it below:
      </div>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <TextField
          label={'YYYY (optional)'}
          className={classes.textField}
          value={moreInfo.year}
          onChange={(e) => handleChange('year', e)}
          autoFocus
          margin="normal"
        />

        {moreInfo.year && validateYear(moreInfo.year).isValid && (
          <TextField
            label={'MM (optional) 1 to 12'}
            className={classes.textField}
            value={moreInfo.month}
            onChange={(e) => handleChange('month', e)}
            autoFocus
            type={'Number'}
            inputProps={{
              min: 1,
              max: 12,
            }}
            margin="normal"
          />
        )}

        {moreInfo.month && validateMonth(moreInfo.month).isValid && (
          <TextField
            label={'DD (optional) 1 to 31'}
            className={classes.textField}
            value={moreInfo.day}
            onChange={(e) => handleChange('day', e)}
            type={'Number'}
            inputProps={{
              min: 1,
              max: 31,
            }}
            margin="normal"
          />
        )}
      </div>

      <div />

      <TextField
        label={'Share Your story (optional)'}
        rows={5}
        placeholder={'Enter your story'}
        className={classes.storyTextField}
        value={moreInfo.desc}
        onChange={(e) => handleChange('desc', e)}
        multiline
        margin="normal"
        variant={'outlined'}
      />

      <Geosuggest
        placeholder={'Search for location (optional)'}
        style={{
          input: {
            width: 300,
            padding: 10,
            margin: 16,
            boxSizing: 'border-box',
          },
          suggests: {
            maxWidth: 300,
            listStyleType: 'none',
            padding: 0,
          },
          suggestItem: {
            width: 200,
            textAlign: 'start',
            cursor: 'pointer',
            boxSizing: 'border-box',
            padding: '10px 0',
          },
        }}
        onSuggestSelect={onSuggestSelect}
        initialValue={moreInfo.location.label}
      />

      <div
        style={{
          fontSize: 16,
          display: error ? 'block' : 'none',
          color: red[500],
        }}
      >
        {error}
      </div>
    </div>
  )
}
